import { Status } from '@amagimedia/amagi-design-system';
import { DELIVERY_STATUS_MAP } from '../constants';
import { DeliveryRequestState, IArtWork, IDeliveryDesc } from '../types';

interface IDeliveryStatus {
  status: string;
  prependMessage: string;
  suffixMessage: string;
  showWarningIcon?: boolean;
}

export function getDeliveryStatus({
  status,
  prependMessage,
  suffixMessage,
  showWarningIcon = false,
}: IDeliveryStatus): string | JSX.Element {
  if (!status) {
    return '-';
  }
  const label = prependMessage ? `${prependMessage} ${status}` : status;
  if (status === DELIVERY_STATUS_MAP.STARTED) {
    return (
      <Status
        type={showWarningIcon ? 'warning' : 'success'}
        label={
          prependMessage && suffixMessage
            ? `${prependMessage} ${suffixMessage}`
            : prependMessage
            ? label
            : `${suffixMessage}`
        }
      />
    );
  }
  if (status === DELIVERY_STATUS_MAP.DRAFT) {
    return <Status type="draft" label={`Delivery in draft`} />;
  }
  if (
    status === DELIVERY_STATUS_MAP.PROVISIONING ||
    status === DELIVERY_STATUS_MAP.STARTING ||
    status === DELIVERY_STATUS_MAP.STOPPING
  ) {
    return <Status type="processing" label={label} />;
  }
  if (
    status === DELIVERY_STATUS_MAP.FAILED ||
    status === DELIVERY_STATUS_MAP.STOPPED
  ) {
    return <Status type="error" label={label} />;
  }
  return status;
}

export function isThereMissingInfoPresent(
  missingDesc: Record<string, IDeliveryDesc>,
  missingArtworks: Record<string, IArtWork>,
) {
  if (
    Object.keys(missingArtworks).length === 0 &&
    Object.keys(missingDesc).length === 0
  ) {
    return false;
  }
  return true;
}

export function getDeliveryRequestStatus(
  status: string,
  state?: DeliveryRequestState,
) {
  if (!state) {
    return '-';
  }
  if (state === 'not_sent') {
    return <Status type="not-sent" label="Not Sent" />;
  }
  if (state === 'sent') {
    return <Status type="sent" label="Sent" />;
  }
  if (state === 'accepted') {
    return <Status type="accepted" label="Accepted" />;
  }
  if (state === 'rejected') {
    return <Status type="error" label="Rejected" />;
  }
  if (state === 'revoked') {
    return <Status type="error" label="Revoked" />;
  }
  if (state === 'delivery_stopped') {
    return <Status type="error" label="Streaming Stopped by Platform" />;
  }
  return status;
}

export function getDeliveryMonetisationStatus(
  status: boolean,
  prependMessage?: string,
) {
  if (status) {
    return (
      <Status
        type="monetised"
        label={prependMessage ? prependMessage : 'Monetisation Enabled'}
      />
    );
  }
  return <Status type="not-monetised" label="Not Monetised" />;
}
